import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { hotTopics } from "@/mocks/home";

export default function HotTopics() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="topics" className="bg-background-100 scroll-mt-20">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Hot Topics"
          title="热议事件 · 大家都在讨论什么"
          description="挑出讨论量最高的几个事件，标题优先、配图克制，把注意力留给事实与观点本身。"
          accent="accent"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {hotTopics.map((topic) => (
            <article
              key={topic.id}
              className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="h-40 w-full overflow-hidden">
                <img
                  src={topic.image}
                  alt={`${topic.title} 相关主题图`}
                  title={`${topic.title} 44黑料区热点讨论`}
                  className="h-full w-full object-cover object-top"
                />
              </div>

              <div className="flex flex-1 flex-col p-4">
                <span className="w-fit rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-medium text-accent-900">
                  {topic.category}
                </span>
                <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-foreground-950">
                  {topic.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {topic.excerpt}
                </p>

                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-chat-3-line text-sm" />
                    </span>
                    {topic.comments.toLocaleString()}
                  </span>
                  <button
                    type="button"
                    onClick={() => toggleLike(topic.id)}
                    className={`flex items-center gap-1.5 whitespace-nowrap transition-colors ${
                      liked[topic.id] ? "text-primary-600" : "hover:text-primary-600"
                    }`}
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i
                        className={
                          liked[topic.id] ? "ri-thumb-up-fill text-sm" : "ri-thumb-up-line text-sm"
                        }
                      />
                    </span>
                    {(topic.votes + (liked[topic.id] ? 1 : 0)).toLocaleString()}
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}